import React from 'react'

import { t } from 'src/lib/i18n-react'
import { Button } from '@chatterbug/aaron'

type Props = {
  onUpdatePotentialAppointment: (action: 'CONFIRM' | 'DISMISS') => void
}

const PotentialAppointmentResponse: React.FC<Props> = ({
  onUpdatePotentialAppointment,
}) => {
  return (
    <>
      <Button
        data-testid="reject-button"
        as="submit"
        onClick={() => onUpdatePotentialAppointment('DISMISS')}
        type="primaryAdvanced"
        fill="outline"
      >
        {t('Dismiss')}
      </Button>
      <Button
        data-testid="confirm-button"
        as="submit"
        onClick={() => onUpdatePotentialAppointment('CONFIRM')}
        type="primaryAdvanced"
      >
        {t('Confirm')}
      </Button>
    </>
  )
}

export default PotentialAppointmentResponse
